import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { sessionService } from '../../services/SessionService';
import { http } from '../../services/HttpInterceptor';
import {
    RouteComponentProps, Link
} from "react-router-dom";
import { toast } from 'react-toastify';
import { observable } from 'mobx';

interface IndexSupportVisitsProps extends RouteComponentProps {
    changeToggle(action?: boolean): void
}
@observer export default class IndexSupportVisits extends React.Component<IndexSupportVisitsProps> {

    @observable private support_tickets: any;
    @observable private isLoaded = false;
    @observable private page: any = 1;
    @observable private sortBy: any = "s.id";
    @observable private sortOrder: any = "DESC";

    componentDidMount() {
        this.props.changeToggle(true);
        this.init();
    }

    init = () => {
        http.get('/api/support/read').then((response) => {
            const obj = JSON.stringify({
                user: sessionService.getUserInfo().id,
                status: "Pendiente Visita",
                page: this.page,
                sort_by: this.sortBy,
                sort_order: this.sortOrder
            });
            http.post('/api/support/read', obj).then((response) => {
                this.support_tickets = response.data.response.data;
                this.isLoaded = true;
            }).catch((error) => {
                toast.error("Error cargando tickets de soporte");
            });
        }).catch((error) => {
            toast.error("Error cargando tickets de soporte");
        });
    }

    render() {
        if (!this.isLoaded) {
            return null;
        }
        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header card-header-primary">
                                <h4 className="card-title ">Lista de tickets de soporte</h4>
                                <p className="card-category">Lista de tickets de soporte generados</p>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table">
                                        <thead className=" text-primary">
                                            <tr>
                                                <th>ID</th>
                                                <th># Contrato</th>
                                                <th>Status</th>
                                                <th>Creado</th>
                                                <th className="text-right">Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.support_tickets.map((support: any, index: any) => {
                                                    return (
                                                        <Fragment key={index}>
                                                            <tr>
                                                                <td>{support.id}</td>
                                                                <td>{support.contract_id}</td>
                                                                <td>{support.status}</td>
                                                                <td>{support.created_date}</td>
                                                                <td className="td-actions text-right">
                                                                    <Link to={`visitas/${support.id}`}>
                                                                        <button style={{ margin: 5 }} type="button" className="btn btn-info">
                                                                            <i className="material-icons">visibility</i>
                                                                        </button>
                                                                    </Link>
                                                                </td>
                                                            </tr>
                                                        </Fragment>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}